import { Box, EmptyState, IconError32, Modal, ModuleHeader } from '@stitch-fix/mode-react';
import { A } from '@mobily/ts-belt';
import { OutfitFragment, useGetOutfitsBySkuQuery } from '../../utils/hooks/getOutfitsBySku';
import { OutfitsCarousel } from '../OutfitsCarousel/OutfitsCarousel';
type OutfitsModalProps = {
  skuId: string;
  open: boolean;
  handleModalClose: () => void;
};
type ClarifiedOutfitFragement = OutfitFragment & {
  __typename: 'Outfit';
};

/**
 * The component renders a Modal and requests outfits to be piped into the
 * Outfits Carousel.
 */
export const OutfitsModal = ({
  skuId,
  open,
  handleModalClose
}: OutfitsModalProps) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useGetOutfitsBySkuQuery({
    variables: {
      skuId
    },
    skip: !open
  });
  const outfits = data?.shopProductVariantBySkuId?.outfitsCollection?.items.nodes.filter((node): node is ClarifiedOutfitFragement => {
    const {
      __typename
    } = node;
    return __typename === 'Outfit';
  }) || [];
  const emptyState = <Box variant="info-light" p={4}>
      <EmptyState heading="No outfits available" primaryAction={{
      children: 'Close',
      onClick: handleModalClose
    }}>
        There aren&apos;t any outfits to show for this item.
      </EmptyState>
    </Box>;
  const errorState = <Box variant="info-light" p={4}>
      <EmptyState heading="Unable to load outfits" image={<IconError32 purpose="decorative" />} primaryAction={{
      children: 'Try again',
      onClick: () => {
        refetch();
      }
    }}>
        Something went wrong.
      </EmptyState>
    </Box>;
  const shouldShowEmptyState = !loading && A.isEmpty(outfits);
  const shouldShowErrorState = !!error;
  const shouldShowOutfitsCarousel = !shouldShowEmptyState && !shouldShowErrorState;
  return <Modal heading={<ModuleHeader mb="default" header="Outfit Ideas" />} isOpen={open} onClose={handleModalClose}>
      {shouldShowEmptyState && emptyState}
      {shouldShowErrorState && errorState}
      {shouldShowOutfitsCarousel && <OutfitsCarousel loading={loading} outfits={outfits} source="saved_items" />}
    </Modal>;
};